module.exports = __webpack_public_path__ + "6fe94382b364ee72d52157848390cf1d.pdf";